export default __webpack_public_path__ + "static/media/error-page.6ad0bc82.png";